import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react'
import { useAuth } from './AuthProvider';

export const pageFromType = (type) => {
    return !type
        ? ''
        : type === 'Admin'? 'main_dashboard' :  type === 'User'
            ? 'enduser_dashboard'
            : type === 'Driver'
                ? 'transportation'
                : type === 'Supplier'
                    ? 'bookings'
                    : '';
};

const RedirectToLogin = () => {
    const { authed, setModel, user: { type } } = useAuth();
    const mainPage = pageFromType(type);
    const navigate = useNavigate();
    useEffect(() => {
        setModel(mainPage);
        navigate(`/${authed ? mainPage : 'login'}`);
    });
    return null;
}

export default RedirectToLogin
